import { ViewShift } from '@xeetr/types/models'

import ApiService from './common/API.service'

export class ShiftService extends ApiService {
  getShifts = async (): Promise<ViewShift[]> => {
    const { data } = await this.get<ViewShift[]>(this.buildCommonUrl('shifts'))
    return data
  }

  patchShift = async (id: string, shift: Partial<ViewShift>): Promise<ViewShift> => {
    const { data } = await this.patch<unknown, ViewShift>(
      this.buildCommonUrl(`shifts/${id}`),
      shift
    )
    return data
  }

  createShift = async (shift: ViewShift): Promise<ViewShift> => {
    const { data } = await this.post<ViewShift, ViewShift>(this.buildCommonUrl('shifts'), shift)
    return data
  }

  deleteShift = async (id: string): Promise<void> => {
    await this.delete(this.buildCommonUrl(`shifts/${id}`))
  }
}
